import { h, Fragment } from "preact";
import { t, translate } from "restaumatic-client";
import { renderPreact } from "../lib/render-preact";
import ProductAvailabilityTag from "./ProductAvailabilityTag";
const HighlightProductTags = (props) => {
    const { tags } = props;
    return (h(Fragment, null,
        tags.includes("New") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.new))),
        tags.includes("Recommended") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.recommended))),
        tags.includes("SpecialOffer") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.special))),
        tags.includes("Bestseller") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.bestseller))),
        tags.includes("TodaySpecial") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.today_special))),
        tags.includes("WeekSpecial") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.week_special))),
        tags.includes("Seasonal") && (h("span", { className: "m-badge m-badge--info" }, translate(t.theme_defaults.dish_label.seasonal)))));
};
const ProductTags = (props) => {
    const { tags, freeModifierItemsCount, labelsCreator, availabilitySchedule } = props;
    return (h(Fragment, null,
        h(HighlightProductTags, { tags: tags }),
        freeModifierItemsCount > 0 && (h("span", { className: "m-badge m-badge--info", title: translate(t.theme_defaults.dish_label.free_toppings) },
            "+",
            freeModifierItemsCount)),
        h(ProductAvailabilityTag, { labelsCreator: labelsCreator, schedule: availabilitySchedule !== null && availabilitySchedule !== void 0 ? availabilitySchedule : undefined })));
};
const StaticProductTags = (props) => {
    const { tags, freeModifierItemsCount, itemId, sectionId, scheduleId, isTemporarilyUnavailable, } = props;
    return (h(Fragment, null,
        h(HighlightProductTags, { tags: tags }),
        freeModifierItemsCount > 0 && (h("span", { className: "m-badge m-badge--info", title: translate(t.theme_defaults.dish_label.free_toppings) },
            "+",
            freeModifierItemsCount)),
        h("span", { class: "js-item__label", "data-menu-section-item-id": itemId, "data-menu-section-id": sectionId, "data-availability-schedule-id": scheduleId }, isTemporarilyUnavailable && (h("span", { class: "m-badge m-badge--warning" }, translate(t.client.labels.temporarily_unavailable.text))))));
};
export const SSRProductTags = renderPreact("ProductTags", StaticProductTags);
export default ProductTags;
